import type { Job } from '@atlas/shared';
import { listJobs } from './callables.js';
import { poll, type Unsubscribe } from './poll.js';

/** Poll the jobs created by the current user, newest first. */
export function subscribeToMyJobs(
  _uid: string,
  onUpdate: (jobs: Array<Job & { id: string }>) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  // The server scopes `mine` to the verified caller; the uid is kept in the
  // signature so callers did not change.
  return poll(async () => (await listJobs({ mine: true })).data.jobs, onUpdate, onError);
}

/**
 * Poll every job across all users, newest first. Used for the shared imports
 * view — the listJobs callable lets any allowed user read; mutations stay
 * owner/admin-only.
 */
export function subscribeToAllJobs(
  onUpdate: (jobs: Array<Job & { id: string }>) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  return poll(async () => (await listJobs({})).data.jobs, onUpdate, onError);
}

/** Poll Bullhorn jobs awaiting decrypt, most recently updated first. */
export function subscribeToBullhornDecryptJobs(
  onUpdate: (jobs: Array<Job & { id: string }>) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  return poll(
    async () => (await listJobs({ status: 'awaiting_decrypt' })).data.jobs,
    onUpdate,
    onError,
  );
}
